<template>
    <div class="nav-wrapper">
        <div class="sticky-box">
            <nav class="liquid-glass-nav" ref="liquidGlassNavRef">
                <div class="glass-text-wrapper" ref="glassTextWrapperRef">
                    <!-- Die CSS-Variable --blob-border-radius wird hier gesetzt -->
                    <div class="nav-blob" :style="[blobStyle, { '--blob-border-radius': blobStyle.borderRadiusValue }]">
                    </div>
                    <ul ref="navList">
                        <li><router-link to="/">Willkommen</router-link></li>
                        <li>
                            <router-link to="/projects" :class="{ 'is-active-project-path': isProjectsPathActive }">
                                Projekte
                            </router-link>
                        </li>
                        <li><router-link to="/about">Über mich</router-link></li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>

    <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
        <defs>
            <filter id="glass-distortion" x="0%" y="0%" width="100%" height="100%">
                <feTurbulence type="fractalNoise" baseFrequency="0.019 0.019" numOctaves="2" seed="92" result="noise" />
                <feGaussianBlur in="noise" stdDeviation="2" result="blurred" />
                <feDisplacementMap in="SourceGraphic" in2="blurred" scale="190" xChannelSelector="R"
                    yChannelSelector="G" />
            </filter>
        </defs>
    </svg>
</template>

<script>
export default {
    data() {
        return {
            blobStyle: {
                width: "0px",
                height: "0px",
                top: "50%", // Vertikal zentriert
                transform: "translate(0px, -50%)", // Vertikal zentriert
                opacity: 0,
                borderRadiusValue: "100px", // Initialer Wert für die border-radius CSS-Variable (allgemein rund)
            },
            activeLinkElement: null, // Speichert das DOM-Element des aktiven Links
        };
    },
    computed: {
        isProjectsPathActive() {
            return this.$route.path.startsWith("/projects");
        },
    },
    watch: {
        // Beobachten der Routenänderung, um den Blob beim Laden der Seite oder Navigieren anzupassen
        $route: {
            immediate: true, // Führt den Watcher sofort beim Initialisieren aus
            handler() {
                this.$nextTick(() => {
                    // Kleiner Timeout, um der DOM-Berechnung mehr Zeit zu geben
                    setTimeout(() => {
                        this.setActiveLinkBlob();
                    }, 50);
                });
            },
        },
    },
    mounted() {
        // Setzt den Blob initial, falls ein Link aktiv ist
        this.$nextTick(() => {
            // Kleiner Timeout, um der DOM-Berechnung mehr Zeit zu geben
            setTimeout(() => {
                this.setActiveLinkBlob();
            }, 50);
            // Event Listener für Fenstergrößenänderungen, um den Blob neu zu positionieren
            window.addEventListener("resize", this.setActiveLinkBlob);
        });
    },
    beforeUnmount() {
        // Entfernt den Event Listener, wenn die Komponente zerstört wird
        window.removeEventListener("resize", this.setActiveLinkBlob);
    },
    methods: {
        setActiveLinkBlob() {
            // Findet den aktuell aktiven Link und setzt den Blob darauf
            const navList = this.$refs.navList;
            if (!navList) return;

            const activeLink = navList.querySelector(
                ".router-link-exact-active, .is-active-project-path"
            );
            if (activeLink) {
                this.activeLinkElement = activeLink;
                this.setBlobPosition(activeLink);
            } else {
                this.activeLinkElement = null;
                // Wenn kein aktiver Link gefunden wird, verstecke den Blob
                this.blobStyle = {
                    width: "0px",
                    height: "0px",
                    top: "50%",
                    transform: "translate(0px, -50%)",
                    opacity: 0,
                    borderRadiusValue: "100px", // Setze auf Standardwert, wenn kein Link aktiv ist
                };
            }
        },
        setBlobPosition(element) {
            if (!element) return;

            // Hole das glass-text-wrapper Element über die Ref (neue Referenzpunkt für Blob)
            const glassTextWrapper = this.$refs.glassTextWrapperRef;
            if (!glassTextWrapper) return;

            const glassTextWrapperRect = glassTextWrapper.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();

            // Berechne die linke Position des Links relativ zum glass-text-wrapper Container
            // Dies ist der Abstand von der linken Kante des glass-text-wrapper zur linken Kante des Links
            const blobLeft = elementRect.left - glassTextWrapperRect.left;

            // Passe die finale linke Position für den Blob an.
            // Wir ziehen 10px ab, um den Blob (der 20px breiter ist) um die Mitte des Links zu zentrieren.
            const finalBlobLeft = blobLeft - 10;

            // Setze den border-radius immer auf allgemein rund
            const borderRadius = "100px";

            this.blobStyle = {
                width: `${elementRect.width + 20}px`, // Zusätzlicher Padding für den Blob
                height: `${elementRect.height + 10}px`, // Zusätzlicher Padding für den Blob
                top: "50%", // Vertikal zentriert
                left: `${finalBlobLeft}px`, // Setze die horizontale Position direkt über 'left'
                transform: `translateY(-50%)`, // Nur vertikale Zentrierung über transform
                opacity: 1,
                borderRadiusValue: borderRadius, // Setze den dynamischen border-radius Wert
            };
        },
    },
};
</script>

<style lang="scss">
// https://www.liquid-glass.pro/generator.html
@use "~@/assets/scss/variables" as *;

a {
    &.button {
        padding: 0.75em 1.5em;
        border: 2px solid #712cf9;
        border-radius: 48px;
        display: inline-block;
    }

    &:not(.not_bubbled) {
        position: relative;
        z-index: 2;

        &:hover {
            color: black;
            opacity: 1;
        }

        &.router-link-exact-active {
            color: white;

            &:before {
                transform: scale(1);
                opacity: 1;
            }
        }

        &:before {
            content: "";
            position: absolute;
            top: -0.5em;
            right: -0.5em;
            left: -0.5em;
            bottom: -0.5em;
            z-index: -1;
            border-radius: 100px;
            background-color: #712cf9;
            transition: all 0.25s ease-out;
            transform: scale(0);
            opacity: 0;
        }

        &:hover {
            &:not(.router-link-exact-active) {
                &:before {
                    opacity: 0.25;
                    transform: scale(1);
                }
            }
        }
    }
}

.sticky-box {
    z-index: 99;
    position: sticky;
    text-align: center;
    top: calc(100% - 3.5em);
    width: 100%;
}

.nav-wrapper {
    left: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: calc(640px + 2em);
    z-index: 99;
    transform: translate(-50%, 0);
    pointer-events: none !important;
}

/* Anpassungen für das Liquid Glass Styling */
.liquid-glass-nav {
    display: inline-block;
    position: relative;
    padding: 0.25em 0.7em; // Beibehalten der ursprünglichen em-Einheit
    border-radius: 100px;
    background: none; // Hintergrund entfernen, da er durch ::before gesetzt wird
    transform: translateY(-50%);
    width: auto;
    height: 64px;
    isolation: isolate;
    box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.2);
    vertical-align: center;
    border: none;
    margin: 0;
    text-decoration: none;
    pointer-events: all !important;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 0;
        box-shadow: inset 0 0 50px 2px #4e0acd;
        background-color: rgba(113, 44, 249, 0.68);
    }

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        z-index: -1;
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
        filter: url(#glass-distortion);
        -webkit-filter: url(#glass-distortion);
    }

    &.back {
        display: none;
        margin-right: -4em;
        width: 8em;
    }

    ul {
        margin-top: 0;
        margin-bottom: 0;
        position: relative;
        z-index: 1;
        display: flex;
        /* Verwende flexbox für bessere Zentrierung der Links */
        align-items: center;
        /* Vertikal zentrieren */
        height: 100%;
        /* Wichtig für vertikale Zentrierung der Links im ul */

        li {
            display: inline-block;
            margin: 0 10px;

            a {
                position: relative;
                display: block;
                z-index: 2;
                opacity: 1;
                transform: translate(0px, 0px);
                color: white !important;
                padding: 5px 0; // Füge etwas Padding hinzu, um die Klickfläche zu vergrößern
                transition: color 0.3s ease, transform 0.3s ease;
                /* Transition für den Hover-Effekt */

                &:hover {
                    &:before {
                        content: initial;
                    }
                    opacity: 0.9;
                    transform: scale(1);
                    /* Beispiel: Leicht vergrößern */
                }
                //&:hover:not(.router-link-active.router-link-exact-active) {
                    //text-decoration: underline;
                //}

                &.is-active-project-path {
                    color: black !important;
                }

                &.router-link-active,
                &.router-link-exact-active {
                    color: black !important;

                    &:before {
                        content: initial;
                    }
                }
            }
        }
    }
}

.glass-text-wrapper {
    position: relative;
    /* Setze dies auf 'relative', damit der Blob darin positioniert werden kann */
    color: #ffffff !important;
    opacity: 1;
    transform: translate(0px, 0px);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
}

.nav-blob {
    position: absolute;
    top: 50%;
    /* Vertikal zentrieren */
    left: 0;
    /* Starte an der linken Kante des Parent-Containers */
    background-color: none; // Farbe des Blobs (wird durch ::before gesetzt)
    z-index: 0; // Liegt hinter den Links
    // Angepasste Transition für "Squish-and-Stretch"-Effekt
    transition: width 0.3s ease,
        /* Zurück zu ease */
        height 0.3s ease,
        /* Zurück zu ease */
        left 0.3s ease, opacity 0.3s ease, border-radius 0.3s ease;
    box-shadow: 0 0 15px rgba(149, 103, 241, 0.7);
    transform: translateY(-50%);
    /* Korrektur für vertikale Zentrierung */
    overflow: hidden;
    border-radius: 100px;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 0;
        box-shadow: inset 0 0 32px 0px rgb(255 255 255 / 20);
        background-color: rgb(255 255 255 / 70%);
        border-radius: var(--blob-border-radius, 100px);
        transition: border-radius 0.3s ease;
    }

    &::after {
        content: "";
        /* position: absolute; */
        inset: 0;
        z-index: -1;
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
        filter: url(#glass-distortion);
        -webkit-filter: url(#glass-distortion);
        border-radius: var(--blob-border-radius, 100px);
        transition: border-radius 0.3s ease;
    }
}

@media (prefers-color-scheme: light) {

    body:not(.dark) .nav-wrapper nav.liquid-glass-nav ul li a,
    body.light .nav-wrapper nav.liquid-glass-nav ul li a {
        color: white !important;
    }
}

@media (max-width: 360px) {
    .sticky-box {
        padding: 0 16px;
    }

    .liquid-glass-nav {
        padding: 0.25em 1em;
        height: 56px;
    }

    .glass-text-wrapper {
        font-size: clamp(2vw, 0.8em, 5vw);

        ul {
            li {
                margin-left: 8px;
                margin-right: 8px;

                &:first-of-type {
                    margin-left: 0 !important;
                }

                &:last-of-type {
                    margin-right: 0 !important;
                }
            }
        }
    }
}
</style>
